export const DEFAULT_FRAME_FONT = 'var(--font-frame-default)'

export const CURSIVE_FRAME_FONT = 'var(--font-frame-cursive)'

export const CURSIVE_FRAME_FALLBACK_FONT = 'var(--font-frame-cursive-fallback)'

export type TFrameFont =
	| typeof DEFAULT_FRAME_FONT
	| typeof CURSIVE_FRAME_FONT
	| typeof CURSIVE_FRAME_FALLBACK_FONT

export type TFrameFallbackFont = typeof CURSIVE_FRAME_FALLBACK_FONT

export const TRANSPARENT_COLOR = 'transparent'

export const FRAME_BLACK = '#000000'

export const FRAME_LIGHT_GREY = '#E6E7ED'

export const FRAME_MEDIUM_GREY = '#84868E'

export const FRAME_DARK_GREY = '#5A5C66'

export const DEFAULT_FRAME_TEXT_MAX_WIDTH = 52

export const DEFAULT_FRAME_TEXT_MAX_SIZE = 9
